import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-accueil-et-gestion-service',
  imports: [RouterLink],
  templateUrl: './accueil-et-gestion-service.html',
  styleUrl: './accueil-et-gestion-service.scss',
})
export class AccueilEtGestionService {

}
